import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

/**
 * NQ StatCard — the hero stat tile. Tone `glow` applies the prestige animated
 * glow (see .nq-glow in theme.css) used by the Alpha-vs-SP500 card. Shared
 * across portfolio + comparison surfaces.
 */
const statCardVariants = cva('rounded-xl border p-4.5', {
  variants: {
    tone: {
      default: 'border-border bg-[color:var(--nq-surface-card)]',
      primary:
        'border-[color:var(--nq-stat-primary-border)] bg-[image:var(--nq-grad-stat-primary)]',
      glow: 'nq-glow nq-glow-strong border-transparent bg-[image:var(--nq-grad-alpha)]',
    },
  },
  defaultVariants: { tone: 'default' },
});

export interface StatCardProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof statCardVariants> {}

export function StatCard({ className, tone, ...props }: StatCardProps) {
  return <div className={cn(statCardVariants({ tone }), className)} {...props} />;
}

/** Small uppercase tracked label used above metrics. */
export function StatLabel({
  className,
  tone,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & { tone?: 'muted' | 'up' }) {
  return (
    <span
      className={cn(
        'text-[11px] font-semibold uppercase tracking-[0.06em]',
        tone === 'up' ? 'text-positive/85' : 'text-muted-foreground',
        className
      )}
      {...props}
    />
  );
}
